/**
 * @fileoverview Agent definition for prose-expander-v2.
 *
 * This agent expands a chapter draft, roughly doubling its length while
 * maintaining the story's voice, tone, and narrative consistency.
 *
 * @category narrative.prose.revision
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'prose-expander-v2',
  kind: 'primitive',
  name: 'Prose Expander',
  description: 'Expands a chapter draft to roughly double its length while maintaining voice and consistency.',
  category: 'writing',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-01',
    lastUpdated: '2026-01',
    taxonomyPath: 'narrative.prose.revision',
    usedBy: [
      'use-prose-expander-v2.ts',
      'use-ai-control-panel.ts',
    ],
    usedInComposites: [],
    relatedAgents: [
      'draft-refiner-v2',
      'prose-shortener-v2',
      'selection-reviser-v2',
    ],
  },
};
